import { forwardRef, ReactNode } from 'react'
import { Modal, Pressable, ScrollView, StyleSheet, View } from 'react-native'
import { isAndroid } from '../../../constants/platform'
import { shadow } from '../../../utils/shadow'

interface MenuPaperProps {
    children: ReactNode
    open: boolean
    onDismiss: () => void
}

export default forwardRef<View, MenuPaperProps>(function MenuPaper(
    { children, open, onDismiss },
    ref
) {
    return (
        <Modal
            transparent
            visible={open}
            supportedOrientations={['landscape']}
            onRequestClose={onDismiss}
            style={styles.container}
        >
            <Pressable onPress={onDismiss} style={styles.underlay} />
            <View ref={ref} style={styles.paperOuterContainer}>
                <View style={styles.paperInnerContainer}>
                    <ScrollView style={styles.paper}>{children}</ScrollView>
                </View>
            </View>
        </Modal>
    )
})

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
    },
    underlay: {
        flex: 1,
    },
    paperOuterContainer: {
        position: 'absolute',
    },
    paperInnerContainer: {
        borderRadius: 6,
        ...shadow({
            elevation: 3,
            color: '#000000',
            offsetHeight: 0,
            offsetWidth: 0,
            opacity: 0.24,
            radius: 6,
            rgba: 'rgba(0, 0, 0, 0.24)',
        }),
        position: 'absolute',
        top: 60 - 8,
        right: 0,
        overflow: isAndroid ? 'hidden' : 'visible',
    },
    paper: {
        backgroundColor: '#FFFFFF',
        borderRadius: 6,
        maxHeight: 375,
    },
})
